//ACITONCOPYRIGHT.SET_ACTIVITY_CONTENT
import { merge, get, set, concat, clone } from 'lodash';
import { ACTIONREPORT } from '../../../actionTypes';
let initState = {
	reportDemoData: {}
};
export function ReportDemoReducers(state = initState, action) {
	switch (action.type) {
		case ACTIONREPORT.SET_REPORT_DEMO: {
			let payload = get(action, 'payload', []);
			let { data = {} } = payload || {};
			state.reportDemoData = clone(data);
			return merge({}, state, {});
		}
		default:
			return state;
	}
}
